import { CategoryUnionType } from '@api';
import type { CompanyLinkCategoryUnionType } from 'src/api/generated/touring/types';

export const mapCompanyLinkCategoriesType = (
  apiType: CompanyLinkCategoryUnionType[] | undefined
): CategoryUnionType[] => {
  if (!apiType) return [];
  return apiType.map((category) => category as CategoryUnionType);
};
